import React, { useState, useEffect, useContext } from "react";
import "./updateSchedule.scss";
import TeleConsultRegularForm from "./TeleConsultRegularForm";
import InClinicRegularForm from "./InClinicRegularForm";
import InClinicFollowUpForm from "./InClinicFollowUpForm";
import ProcedureForm from "./ProcedureForm";
import TeleConsultFollowUpForm from "./TeleConsultFollowUpForm";
import InstructionModal from "../Modals/InstructionModal";
import Info from "../../../../assets/info.png";
import ConsultationModal from "../Modals/ConsultationModal";
import MyScheduleModal from "../Modals/MyScheduleModal";
import MyScheduleFeesContext from "../MyScheduleFeesContext";
import { UPDATE_SCHEDULE } from "../Constants";
import { USER_ROLE } from "../../../../Util/constants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";

export default function ConsultationSettingsContainer(props) {
  const {
    getProcedure,
    dropdownOptions,
    procedure_length,
    handleSlotType,
    slotValue,
    handleEnableAllSLotButton,
    handleConsultationCounter,
    handleProcedureCounter,
    staffDoctor,
    onViewLogClick,
    isResourceArray,
    setCommonProcedure
  } = props;
  const text =
    "Cannot update consultation setting as there are some upcomming appointment present for the given consultation";
  const myScheduleFeesContext = useContext(MyScheduleFeesContext);
  const [consultationType, setConsultationType] = useState("");
  const [consultationId, setConsultationId] = useState("");
  const [procedureId, setProcedureId] = useState("");
  const [showInstructionModal, setInstructionModal] = useState(false);
  const [showConsultationModal, setConsultationModal] = useState(false);
  const [showTeleConsultRegular, setTeleConsultRegularModal] = useState(false);
  const [showTeleConsultFollowUp, setTeleConsultFollowUpModal] =
    useState(false);
  const [showInClinicRegular, setInClinicRegularModal] = useState(false);
  const [showInClinicFollowUp, setInClinicFollowUpModal] = useState(false);
  const [title, setTitle] = useState("");
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  // Set props data for further use within the component
  useEffect(() => {
    setConsultationType(props.consultationType);
    setConsultationId(props.consultationId);
    setProcedureId(props.procedureId);
  }, [props.consultationType, props.consultationId, props.procedureId]);

  //function to close instruction modal
  const handleInstructionModal = () => {
    setInstructionModal(false);
  };

  //function to close consultation modal
  const closeConsultationModal = () => {
    setConsultationModal(false);
  };

  //function to open consultation modal
  const openConsultationModal = () => {
    setConsultationModal(true);
  };

  //function to close teleconsult regular modal
  const closeTeleConsultRegularModal = (value) => {
    if (value == "yes") {
      dropdownOptions.map((data, index) => {
        if (data.id == consultationType.id) {
          myScheduleFeesContext.setSelectedConsultationType(
            dropdownOptions[index + 1]
          );
        }
      });
    }
    setTeleConsultRegularModal(false);
  };
  //function to close teleconsult followup modal
  const closeTeleConsultFollowUpModal = (value) => {
    if (value == "yes") {
      dropdownOptions.map((data, index) => {
        if (data.id == consultationType.id) {
          myScheduleFeesContext.setSelectedConsultationType(
            dropdownOptions[index + 1]
          );
        }
      });
    }
    setTeleConsultFollowUpModal(false);
  };
  //function to close inclinic regular modal
  const closeInClinicRegularModal = (value) => {
    if (value == "yes") {
      dropdownOptions.map((data, index) => {
        if (data.id == consultationType.id) {
          myScheduleFeesContext.setSelectedConsultationType(
            dropdownOptions[index + 1]
          );
        }
      });
    }
    setInClinicRegularModal(false);
  };
  //function to close inclinic followup modal
  const closeInClinicFollowUpModal = (value) => {
    if (value == "yes") {
      if (procedure_length == 5) {
        myScheduleFeesContext.setSelectedConsultationType(
          dropdownOptions[dropdownOptions.length - 2]
        );
      } else {
        myScheduleFeesContext.setSelectedConsultationType(
          dropdownOptions[dropdownOptions.length - 1]
        );
      }
    }
    setInClinicFollowUpModal(false);
  };

  const handleTitle = (data) => {
    setTitle(data);
  };

  function renderSettingForm() {
    switch (consultationType.id) {
      case "0":
        return (
          <TeleConsultRegularForm
            consultationType={consultationType}
            // openConsultationModal={openConsultationModal}
            openConsultationModal={() => setTeleConsultRegularModal(true)}
            handleSlotType={handleSlotType}
            slotValue={slotValue}
            handleEnableAllSLotButton={handleEnableAllSLotButton}
            handleConsultationCounter={handleConsultationCounter}
            handleTitle={handleTitle}
            staffDoctor={staffDoctor}
            warningMsg={text}
          />
        );
      case "1":
        return (
          <TeleConsultFollowUpForm
            consultationType={consultationType}
            // openConsultationModal={openConsultationModal}
            openConsultationModal={() => setTeleConsultFollowUpModal(true)}
            handleSlotType={handleSlotType}
            slotValue={slotValue}
            handleEnableAllSLotButton={handleEnableAllSLotButton}
            handleConsultationCounter={handleConsultationCounter}
            handleTitle={handleTitle}
            staffDoctor={staffDoctor}
            warningMsg={text}
          />
        );
      case "5":
        return (
          <InClinicRegularForm
            consultationType={consultationType}
            // openConsultationModal={openConsultationModal}
            openConsultationModal={() => setInClinicRegularModal(true)}
            handleSlotType={handleSlotType}
            slotValue={slotValue}
            handleEnableAllSLotButton={handleEnableAllSLotButton}
            handleConsultationCounter={handleConsultationCounter}
            handleTitle={handleTitle}
            staffDoctor={staffDoctor}
            warningMsg={text}
          />
        );
      case "6":
        return (
          <InClinicFollowUpForm
            consultationType={consultationType}
            // openConsultationModal={openConsultationModal}
            openConsultationModal={() => setInClinicFollowUpModal(true)}
            handleSlotType={handleSlotType}
            slotValue={slotValue}
            handleEnableAllSLotButton={handleEnableAllSLotButton}
            handleConsultationCounter={handleConsultationCounter}
            handleTitle={handleTitle}
            staffDoctor={staffDoctor}
            warningMsg={text}
          />
        ); //InClinicFollowUpForm
      case "4":
        return (
          <ProcedureForm
            isResourceArray={isResourceArray}
            consultationType={consultationType}
            getProcedure={getProcedure}
            dropdownOptions={dropdownOptions}
            handleSlotType={handleSlotType}
            handleEnableAllSLotButton={handleEnableAllSLotButton}
            handleProcedureCounter={handleProcedureCounter}
            slotValue={slotValue}
            staffDoctor={staffDoctor}
            setCommonProcedure={setCommonProcedure}
          />
        );
      default:
        break;
    }
  }

  return (
    // This form should be driven through consultationType as per requirement
    <>
      <section className="consultation-setting-container">
        <div className="heading-container">
          <div className="font-weight-bold heading">
            {localStorage.getItem("isResourceArray") === "True" ||
              doctorRole == USER_ROLE.RESOURCE_CONSULTANT
              ? "Procedure Setting : "
              : "Consultation Setting"}
            <img
              className="ml-2"
              src={Info}
              onClick={() => setInstructionModal(true)}
            />
          </div>
          <div
            className="view-logs-title"
            onClick={() => onViewLogClick("btm-drawer")}
          >
            View Logs
          </div>
        </div>
        <p className="mb-3">Select duration and fees for your consultation</p>
        <div className="consultation-setting">{renderSettingForm()}</div>
      </section>
      <MyScheduleModal
        show={showConsultationModal}
        name={"consultationModal"}
        okayClickHandler={closeConsultationModal}
      />
      <MyScheduleModal
        show={showInstructionModal}
        name={"instructionModal"}
        okayClickHandler={handleInstructionModal}
      />
      <MyScheduleModal
        show={showInClinicRegular}
        name={"inClinicRegular"}
        okayClickHandler={closeInClinicRegularModal}
        title={title}
        procedureName={consultationType.label}
      />{" "}
      {/** () => { setInClinicRegularModal(false) }*/}
      <MyScheduleModal
        show={showInClinicFollowUp}
        name={"inClinicFollowUp"}
        okayClickHandler={closeInClinicFollowUpModal}
        title={title}
        procedureName={consultationType.label}
      />{" "}
      {/** () => { setInClinicFollowUpModal(false) } */}
      <MyScheduleModal
        show={showTeleConsultRegular}
        name={"teleConsultRegular"}
        okayClickHandler={closeTeleConsultRegularModal}
        title={title}
        procedureName={consultationType.label}
      />{" "}
      {/**() => { setTeleConsultRegularModal(false); } */}
      <MyScheduleModal
        show={showTeleConsultFollowUp}
        name={"teleConsultFollowUp"}
        okayClickHandler={closeTeleConsultFollowUpModal}
        title={title}
        procedureName={consultationType.label}
      />{" "}
      {/** () => { setTeleConsultFollowUpModal(false); } */}
    </>
  );
}
